import React, { useState } from 'react';

const ServiceCard = ({ title, image }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div className={`relative w-[350px] h-[440px] text-[#41220E] bg-center flex justify-center items-center
            ${isHovered ? 'opacity-100' : 'opacity-100'} `}
            style={{
                backgroundImage: `url(${image})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
            }}>
            <div className="absolute inset-0 bg-center flex flex-col justify-end items-center w-full h-full bg-catering-services-shape bg-cover z-10"
                 onMouseEnter={() => setIsHovered(true)}
                 onMouseLeave={() => setIsHovered(false)}>
                
                <div className={`flex items-center justify-center w-[85%] transition-all duration-700 ease-in-out mb-[20px] bg-[#E6F3CD] bg-opacity-80`}>
                    <h3 className="xs:text-[15px] text-[20px] sm:text-[25px] lg:text-[24px] 2xl:text-[25px] font-bold text-center text-shadow-outline py-[20px]">
                        {title}
                    </h3>
                </div>
            </div>
        </div>
    );
};

export default ServiceCard;
